import Service from "../../AuthService";
const purchaseOrder = {
    getPurchaseOrder(page) {
        return Service.get("/purchase-order?page="+page);
    },
    showPurchaseOrder(id) {
        return Service.get("/purchase-order/"+id);
    },
    createPurchaseOrder(data) {
        return Service.post("/purchase-order" ,data);
    },
    updatePurchaseOrder(id,data) {
        return Service.put("/purchase-order/"+id ,data);
    },
    deletePurchaseOrder(id){
        return Service.delete("/purchase-order/"+id );
    },
    savePurchaseOrder(data) {
        return Service.post("/create-purchase-order" ,data);
    },
    getAllPurchaseOrder(){
        return Service.get("/purchase-order-getAll");
    },
    searchPurchaseOrder(page,po,date_start,date_end,vendor,excel,status){
        return Service.get('/purchase-order-search?page=' +page+
            '&po=' + po+'' +
            '&date_start='+date_start+'' +
            '&date_end='+date_end+'' +
            '&excel='+excel+'' +
            '&status='+status+'' +
            '&vendor='+vendor);
    },
    selectPurchaseOrderAll(data){
        return Service.post('/selectPurchaseOrderAll',data);
    },
    getPurchaseOrderNotCreateRR(){
        return Service.get('/purchase_order_not_rr');
    },
    generatePO(date){
        return Service.get('/generate_po_number?date='+date);
    }
};
export default purchaseOrder;
